import apiRequest from "src/utils/api-request";
import withApiPath from "src/utils/with-api-path";

export interface MerchantInfo {
	id: number;
	uuid: string;
	name: string;
	website: string;
	createdAt: string;
	status: string;
	creatorName?: string;
	creatorEmail?: string;
}

export interface MerchantBalanceItem {
	currency: string;
	blockchain: string;
	amount: string;
	usd?: number;
}

export interface MerchantHeadline {
	totalBalanceUsd: number;
	lifetimeVolumeUsd: number;
	totalOrders: number;
	paidOrders: number;
	uniqueCustomers: number;
	platformRevenueUsd: number;
	orderRevenueUsd: number;
	withdrawalRevenueUsd: number;
	energyCostUsd: number;
	energyCostTrx: number;
	netContributionUsd: number;
}

export interface MerchantRecentActivity {
	ordersLast24h: number;
	ordersLast7d: number;
	ordersLast30d: number;
	activePaymentLinks: number;
}

export type SeriesGranularity = "day" | "month";

export interface MerchantSeriesPoint {
	date: string;
	orderCount: number;
	paidCount: number;
	volumeUsd: number;
}

export interface MerchantVolumeSlice {
	label: string;
	volume: number;
	orderCount: number;
	percentage: number;
}

export interface MerchantDetail {
	merchant: MerchantInfo;
	balances: MerchantBalanceItem[];
	headline: MerchantHeadline;
	recentActivity: MerchantRecentActivity;
	granularity: SeriesGranularity;
	orderSeries: MerchantSeriesPoint[];
	currencyBreakdown: MerchantVolumeSlice[];
}

const merchantDetailProvider = {
	async get(
		merchantUuid: string,
		startDate: string,
		endDate: string,
	): Promise<MerchantDetail> {
		const query = `?start_date=${startDate}&end_date=${endDate}`;
		const response = await apiRequest.get<MerchantDetail>(
			withApiPath(`/merchants/${merchantUuid}${query}`),
		);
		return response.data;
	},
};

export default merchantDetailProvider;
